import MobileTopPanel from './Component';

export default MobileTopPanel;